import React, { useState } from 'react';
import './AddBrandModal.styles.css';
import apiService from '../../services/api';

const AddBrandModal = ({ isOpen, onClose, onSave }) => {
    const [brandName, setBrandName] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [useForRepair, setUseForRepair] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [apiError, setApiError] = useState(null);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!brandName.trim()) {
            alert('Brand name is required');
            return;
        }

        setIsSaving(true);
        setApiError(null);

        try {
            const res = await apiService.createBrand({
                name: brandName.trim(),
                description: shortDescription.trim(),
                use_for_repair: useForRepair
            });

            const createdBrand = res.data || res;

            // Pass the new brand object back to parent so it can update dropdown lists
            if (onSave) {
                onSave(createdBrand);
            }

            // Reset and close
            setBrandName('');
            setShortDescription('');
            setUseForRepair(false);
            setApiError(null);
            onClose();
        } catch (err) {
            setApiError('Failed to create brand: ' + err.message);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="modal-overlay add-brand-overlay">
            <div className="modal-container add-brand-modal">
                <div className="modal-header">
                    <h2>Add brand</h2>
                    <button className="modal-close-btn" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-content">
                        {apiError && (
                            <div style={{
                                marginBottom: '1rem',
                                padding: '0.6rem 0.9rem',
                                background: '#fef2f2',
                                border: '1px solid #fecaca',
                                borderRadius: '6px',
                                color: '#991b1b',
                                fontSize: '0.85rem'
                            }}>
                                {apiError}
                            </div>
                        )}

                        <div className="form-group">
                            <label>Brand name:*</label>
                            <input
                                type="text"
                                value={brandName}
                                onChange={(e) => setBrandName(e.target.value)}
                                placeholder="Brand name"
                                required
                                className="form-control"
                            />
                        </div>

                        <div className="form-group">
                            <label>Short description:</label>
                            <input
                                type="text"
                                value={shortDescription}
                                onChange={(e) => setShortDescription(e.target.value)}
                                placeholder="Short description"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group checkbox-group">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={useForRepair}
                                    onChange={(e) => setUseForRepair(e.target.checked)}
                                />
                                <span className="checkbox-custom-modal"></span>
                                Use for repair?
                                <span className="info-icon" title="Use for repair">ℹ️</span>
                            </label>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isSaving}
                            style={{ opacity: isSaving ? 0.7 : 1, cursor: isSaving ? 'not-allowed' : 'pointer' }}
                        >
                            {isSaving ? 'Saving...' : 'Save'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={isSaving}
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddBrandModal;
